import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Node} from '../node.model';
import {NodeActions, NodeActionTypes} from '../actions/node.actions';

export interface NodeState extends EntityState<Node> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Node> = createEntityAdapter<Node>({
  selectId: node => node.Id
});

export const initialState: NodeState = adapter.getInitialState({
  Loaded: false,
  Loading: true
});

export function sortBySeqLevel(e1: Node, e2: Node) {
  return e1.Level - e2.Level;
}

export function reducer(
  state = initialState,
  action: NodeActions
): NodeState {
  switch (action.type) {
    case NodeActionTypes.GetNodes: {
      return {...state, Loaded: false, Loading: true};
    }

    case NodeActionTypes.AddNode: {
      return adapter.addOne(action.payload.node, state);
    }

    case NodeActionTypes.UpsertNode: {
      return adapter.upsertOne(action.payload.node, state);
    }

    case NodeActionTypes.AddNodes: {
      return adapter.addMany(action.payload.nodes, state);
    }

    case NodeActionTypes.UpsertNodes: {
      return adapter.upsertMany(action.payload.nodes, state);
    }

    case NodeActionTypes.UpdateNode: {
      return adapter.updateOne(action.payload.node, state);
    }

    case NodeActionTypes.UpdateNodes: {
      return adapter.updateMany(action.payload.nodes, state);
    }

    case NodeActionTypes.DeleteNode: {
      return adapter.removeOne(action.payload.id, state);
    }

    case NodeActionTypes.DeleteNodes: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case NodeActionTypes.LoadNodes: {
      return adapter.setAll(action.payload.nodes, {...state, Loaded: true, Loading: false});
    }

    case NodeActionTypes.ClearNodes: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const selectAllNodes = selectAll;
